import { Button } from "@/components/ui/button";

export default function LoadError({ message, onRetry, retrying = false }) {
  if (!message) return null;
  return (
    <div role="alert" className="flex items-center justify-between gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
      <span className="min-w-0 break-words">{message}</span>
      {onRetry && <Button type="button" size="sm" variant="outline" disabled={retrying} onClick={onRetry} className="shrink-0">{retrying ? "Загрузка..." : "Повторить"}</Button>}
    </div>
  );
}
